export default {
  variants: {
    basic: () => ({
      track: {
        bg: 'mld.neutral.600',
        _checked: {
          bg: 'mld.neutral.900',
        },
      },
    }),
  },
}
